import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { ProvinceDetailForm } from "@/features/province/ProvinceDetailForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function ProvinceDetail() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/province",
            label: "Province",
          },
          {
            label: "Detail",
          },
        ]}
      />
      <H2>Province Detail</H2>
      <ProvinceDetailForm id={id} />
    </>
  );
}
